import { mapGetters, mapActions } from 'vuex'

const moduleName = 'booking'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      lastCalendarView: 'lastCalendarView'
    })
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'addStoreItem','addStoreItemRoute', 'saveSnapshot', 'clearSnapshots', 'setReturnRoute', 'setLastCalendarView']),
    ...mapActions('quotes', { setQuoteReturnRoute: 'setReturnRoute', editStoreQuote: 'editStoreItem' })
  }
}
